module.exports = __webpack_public_path__ + "static/media/left.24993e04.png";